<template>
  <section :data-theme="theme"  v-intersection-observer="onIntersectionObserver">
    <div
      class="hero min-h-screen bg-base-100 p-4"
     
    >
      <!-- mt-12 md:mt-0 ??? -->
      <div class="hero-content flex justify-center">
        <div>
          <h1>404 - Página no encontrada.</h1>
          <p>Esta página ya no existe o fue movida a otra ubicación.</p>
          <router-link to="/" class="btn btn-primary mt-4 text-black"
            >Regresar al inicio</router-link
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useStore } from "vuex";
import { ref } from "vue";

import { vIntersectionObserver } from "@vueuse/components";

const isVisible = ref(false);
const theme = ref("forest");
const store = useStore();

function onIntersectionObserver([{ isIntersecting }]) {
  if (isIntersecting) {
    store.dispatch("setTheme", theme.value);
  }
  isVisible.value = isIntersecting;
}
</script>

<style>
</style>